import { APIDECK_CLEANUP, apiDeckIntegrationRoutine, externalApiDeckIntegrationCompleteRoutine, routeNameAfterIntegrationRoutine } from '@/store/modules/apiDeck/routines'
import requestFlow from '@/utils/requestFlow'

export default {
  ...requestFlow(apiDeckIntegrationRoutine).mockMutations,

  [apiDeckIntegrationRoutine.FAILURE](state, payload) {
    state.apiDeckError = payload || null
  },

  [apiDeckIntegrationRoutine.SUCCESS](state, payload) {
    state.apiDeckIntegration = payload || null
    // reset previous errors if success
    state.apiDeckError = null
  },

  [routeNameAfterIntegrationRoutine.TRIGGER](state, payload) {
    state.routeNameAfterIntegration = payload
  },

  [externalApiDeckIntegrationCompleteRoutine.TRIGGER](state, payload) {
    state.isExternalApiDeckIntegrationComplete = payload
  },

  [APIDECK_CLEANUP](state, payload) {
    Object.assign(state, payload)
  }
}
